module.exports = __webpack_public_path__ + "static/img/06.473da19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8/06.jpg
// module id = cvtz
// module chunks = 1